import React from 'react';

const CLOUDFRONT_URL = 'https://d216jeh2etz7vb.cloudfront.net';

const videos = [
  {
    title: 'Why I Am Starting a Life Journal at 27',
    caption: 'A placeholder caption for this video.',
    src: `${CLOUDFRONT_URL}/videos/why_im_starting_a_life_journal_at_27_longform.mp4`,
  },
  {
    title: 'Creating Memories Through Video (Thailand and Indonesia 2025)',
    caption: 'A placeholder caption for this video.',
    src: `${CLOUDFRONT_URL}/videos/final_with_music.mp4`,
  },
  {
    title: 'Practicing Storytelling Through Video (Hawaii 2026)',
    caption: 'A placeholder caption for this video.',
    src: `${CLOUDFRONT_URL}/videos/hawaii_june_2026_with_music.mp4`,
  },
  {
    title: 'Yuzu Goes to San Francisco',
    caption: 'A placeholder caption for this video.',
    src: `${CLOUDFRONT_URL}/videos/yuzugoestosf_ytaudio.mp4`,
  },
  {
    title: 'Jumping off a Rock in Henry Cowell',
    caption: 'A placeholder caption for this video.',
    src: `${CLOUDFRONT_URL}/videos/Jumping off a rock.mp4`,
  },
];

const Videos = () => {
  return (
    <div className="videos-page">
      <div className="container">
        <h1>Videos</h1>
        <div className="videos-list">
          {videos.map((video, i) => (
            <div className="video-entry" key={i}>
              <h2>{video.title}</h2>
              <p className="video-caption">{video.caption}</p>
              <video
                controls
                playsInline
                preload="metadata"
                className="video-player"
              >
                <source src={video.src} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Videos;
